const clickHandler = (e: MouseEvent): void => {
  e.preventDefault()

  const targetElSelector: string | null = (e.target as HTMLLinkElement).getAttribute('href')
  const header: HTMLElement | null = document.querySelector('.header')

  if (!targetElSelector || !header) {
    return
  }

  const targetEl = document.querySelector(targetElSelector)
  const offset = header.getBoundingClientRect().height

  window.scroll({
    behavior: 'smooth',
    top: targetEl?.getBoundingClientRect().top as number - offset
  })
}

export const searchLinksInit = () => {
  const searchLinks: NodeListOf<HTMLLinkElement> = document.querySelectorAll('.search-results__link')

  searchLinks.forEach((link: HTMLLinkElement): void => {
    link.addEventListener('click', clickHandler)
  })
}
